// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2rko1rr0{border-radius:var(--ds-radius-full,9999px)}", ""]);
// Exports
module.exports = exports;
